<template>
  <div class="grid grid-cols-1 h-full">
    <div v-if="audio_is_active && joining_audio">
      <div key="loading" class="flex center-xs middle-xs h-inherit">
        <p>Connecting ....</p>
        <div class="flex justify-center">
          <pl-spinner />
        </div>
      </div>
    </div>
    <div v-else-if="audio_is_active && !joinedAudioDiscussion">
      <div class="flex flex-col w-2/4 items-center justify-center mx-auto">
        <div class="mb-5 text-lg font-bold">Choose video and audio options</div>
        <div v-if="show_avatar">
          <img
            :src="getProfile.avatar_url"
            class="w-20 h-20 rounded-full object-cover"
          />
        </div>
        <video
          v-else
          class="local-camera"
          ref="camera"
          :width="canvasWidth"
          :height="canvasHeight"
          autoplay
        ></video>
        <div class="mt-10 flex items-center w-full">
          <div class="w-10">
            <i class="fa-solid fa-microphone text-2xl" />
          </div>
          <multiselect
            v-model="preferredAudioDevice"
            :options="audioDevices"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="true"
            :preserve-search="true"
            :show-labels="false"
            placeholder="Select microphone"
            label="label"
            track-by="deviceId"
            :limit="1"
            :preselect-first="false"
            :limitText="(count) => `and ${count} more`"
          />
        </div>
        <div class="mt-2.5 flex items-center w-full">
          <div class="w-10">
            <i class="fa-solid fa-video text-2xl" />
          </div>
          <multiselect
            v-model="preferredVideoDevice"
            :options="videoDevices"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="true"
            :preserve-search="true"
            :show-labels="false"
            placeholder="Select camera"
            label="label"
            track-by="deviceId"
            :limit="1"
            :preselect-first="false"
            :limitText="(count) => `and ${count} more`"
          />
        </div>
        <!-- <div @click="handleToggleElement()" class="flex space-x-2 cursor-pointer">
          <div class="w-10 h-6 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out" :class="{ 'bg-primary': is_active }">
            <div class="bg-white w-4 h-4 rounded-full transform duration-300 ease-in-out" :class="{ 'translate-x-4': is_active }">
            </div>
          </div>
          <i :class="{'fa-video-slash text-red-500': !is_active, 'fa-video text-primary': is_active }" class="fa-solid"></i>
        </div> -->
        <button
          class="my-5 rounded bg-primary font-semibold text-white h-9 w-full disabled:opacity-50"
          @click="joinDiscussion"
          :disabled="loading"
        >
          Join RoundTable
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  /* import Vue from 'vue'; */
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import Multiselect from 'vue-multiselect';
  export default {
    data() {
      return {
        circle_is_empty_msg: {
          teacher:
            'Wait for a student to enter the discussion circle or use the left side bar to enter a student',
          student: 'Use the bottom row buttons to enter the discussion circle.',
        },
        joining_audio: false,
        canvasHeight: 150,
        canvasWidth: 350,
        audioDevices: [],
        videoDevices: [],
        preferredAudioDevice: {},
        preferredVideoDevice: {},
        items: [],
        videostream: {},
        show_avatar: false,
        loading: false,
        is_active: true,
      };
    },
    watch: {
      my_participation_id() {
        this.$store.dispatch(
          'fetchParticipationSummary',
          this.getMyParticipation.id
        );
      },
      joinedAudioDiscussion() {
        this.joining_audio = false;
      },
      preferredVideoDevice() {
        this.switchVideoDevice();
      },
    },
    props: {
      joinedAudioDiscussion: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Multiselect,
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'hasTeacherPermissionsInCourse',
        'getMyParticipation',
        'getProfile',
      ]),
      my_participation_id() {
        return this.getMyParticipation.id;
      },
      has_joined_discussion() {
        if (!this.audio_video_is_enabled) return true;
        return this.joinedAudioDiscussion;
      },
      audio_video_is_enabled() {
        return this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
      audio_is_active() {
        return (
          (this.getCurrentDiscussion.audio_discussion_is_enabled &&
            this.getCurrentDiscussion.is_live) ||
          (this.getCurrentDiscussion.audio_discussion_is_enabled &&
            this.getCurrentDiscussion.teacher_tapped_in_id)
        );
      },
    },
    methods: {
      handleToggleElement: async function () {
        this.is_active = !this.is_active;
        return;
      },
      async getDevices() {
        const dev = await navigator.mediaDevices.enumerateDevices();
        this.audioDevices = dev.filter(function (device) {
          return device.kind === 'audioinput';
        });
        this.videoDevices = dev.filter(function (device) {
          return device.kind === 'videoinput';
        });
        this.preferredVideoDevice = this.videoDevices.length
          ? this.videoDevices[0]
          : {};
        this.preferredAudioDevice = this.audioDevices.length
          ? this.audioDevices[0]
          : {};
      },
      async startCameraStream() {
        const constraints = (window.constraints = {
          audio: false,
          video: true,
        });
        const stream = await navigator.mediaDevices
          .getUserMedia(constraints)
          .catch((error) => {
            this.show_avatar = true;
            alert("Browser doesn't support or there is some errors." + error);
          });
        if (stream) {
          this.$nextTick(() => {
            this.videostream = document.querySelector('.local-camera');
            this.videostream.srcObject = stream;
          });
        }
        await this.getDevices();
        this.loading = false;
      },
      switchVideoDevice() {
        if (this.videostream && this.videostream.srcObject) {
          let tracks = this.videostream.srcObject.getTracks();
          tracks.forEach((track) => {
            track.stop();
          });
          const constraints = (window.constraints = {
            audio: false,
            video: {
              deviceId: this.preferredVideoDevice.deviceId
                ? { exact: this.preferredVideoDevice.deviceId }
                : undefined,
            },
          });
          navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
            this.videostream = document.querySelector('.local-camera');
            this.videostream.srcObject = stream;
          });
        }
      },
      joinDiscussion: async function () {
        if (
          this.preferredAudioDevice &&
          this.preferredAudioDevice.deviceId &&
          this.preferredAudioDevice.deviceId !== ''
        ) {
          localStorage.setItem(
            'preferredAudioDevice',
            this.preferredAudioDevice.deviceId
          );
        }
        if (
          this.preferredVideoDevice &&
          this.preferredVideoDevice.deviceId &&
          this.preferredVideoDevice.deviceId !== ''
        ) {
          localStorage.setItem(
            'preferredVideoDevice',
            this.preferredVideoDevice.deviceId
          );
        }
        if (this.videostream && this.videostream.srcObject) {
          let tracks = this.videostream.srcObject.getTracks();
          tracks.forEach((track) => {
            track.stop();
          });
        }
        this.joining_audio = true;
        if (!this.hasTeacherPermissionsInCourse) {
          const student_turn = this.getCurrentDiscussion.turns_in_circle.find(
            (t) => t.participation.user.id === this.getProfile.id
          );
          if (this.audio_video_is_enabled && !student_turn) {
            await this.$store.dispatch('tapIn', {
              discussion_id: this.getCurrentDiscussion.id,
              turn_type: 'video_audio_on',
            });
          }
        }
        
        EventBus.$emit('joinAudioDiscussion');
      },
    },
    async mounted() {
      this.loading = true;
      if (this.getMyParticipation.id) {
        this.$store.dispatch(
          'fetchParticipationSummary',
          this.getMyParticipation.id
        );
      }
      await this.getDevices();
      await this.startCameraStream();

      EventBus.$on('joiningAudioDiscussion', () => {
        this.joining_audio = true;
      });
    },
    beforeDestroy() {
      EventBus.$off('joiningAudioDiscussion');
    },
  };
</script>
<style scoped lang="stylus">
  .local-camera
    transform: scaleX(-1)
    border-radius: 5px;
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// discussionCircleMessages.vue?22526c7e